<template>
  <div class="form-group" :class="{'is-invalid-group':error || errorMessage}">
    <div>
      <div class="textOnInput">
        <label class="form-control-label" for="inputText" v-if="label">
          {{ label }}
        </label>
        <flat-pickr 
          v-bind="$attrs"
          class="form-control"
          :class="[inputClass, { 'is-invalid': error || errorMessage, 'is-valid': !error && !errorMessage && isSelected }]"
          :placeholder="placeholder"
          :options='options'
          @on-change="onChange($event)"
          @input="onInput($event)"
        ></flat-pickr>
      </div>
    </div>

    <div class="text-muted" v-if="help">
      {{ help }}
    </div>
    <div class="invalid-feedback" v-if="errorMessage">
      {{ errorMessage }}
    </div>
    <div class="invalid-feedback" v-else-if="error">
      Please provide a valid {{ name || label || 'input' }}
    </div>
    <div class="text-success" v-else-if="(!error && !errorMessage && isSelected)">
      Looks good!
    </div>
  </div>
</template>

<script>
export default {
  props:[
    'type', 
    'placeholder', 
    'label', 
    'icon', 
    'name', 
    'autocomplete',
    'required', 
    'error', 
    'errorMessage', 
    'help', 
    'options',
    'inputClass'
  ],
  data() {
    return {
      isSelected: false
    }
  },
  methods: {
    onClose(val) {
      this.isSelected = false
      this.$emit('update:name', val)

      // if(val) {
      //   this.isSelected = true
      // }
    },
    onChange(val) {
      this.isSelected = false
      this.$emit('change', val)

      // if(val) {
      //   this.isSelected = true
      // }
    },
    onInput(val) {
      this.isSelected = false
      this.$emit('input', val)

      // if(val) {
      //   this.isSelected = true
      // }
    }
  }
}
</script>